import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/chevron-forward-white.svg'


const _hoisted_1 = { class: "flex flex-col h-screen bg-background" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center h-full"
}
const _hoisted_3 = {
  key: 1,
  class: "container h-full"
}
const _hoisted_4 = { class: "flex flex-col h-full py-8" }
const _hoisted_5 = { class: "flex flex-row items-center justify-between" }
const _hoisted_6 = { class: "text-4xl font-primary" }
const _hoisted_7 = { class: "flex flex-row h-full items-center justify-center" }
const _hoisted_8 = { class: "txt-card-title capitalize" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex flex-row" }
const _hoisted_12 = { class: "mr-4" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Go to ")
const _hoisted_14 = { class: "capitalize" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ModalAddPayment = _resolveComponent("ModalAddPayment")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Loader)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.name), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (product, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "card-main flex flex-col items-center mx-4"
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(product == "sourcing"
                  ? "Talent Sourcing"
                  : "Workforce Solutions"), 1),
                  _createElementVNode("img", {
                    src: require(`@/assets/home-icons/${product}.svg`),
                    class: "w-24 h-24 mt-4"
                  }, null, 8, _hoisted_9),
                  _createElementVNode("button", {
                    class: "btn-filled-lg mt-4",
                    onClick: ($event: any) => (_ctx.sendToPlatform(product))
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, _toDisplayString(product), 1)
                      ]),
                      _hoisted_15
                    ])
                  ], 8, _hoisted_10)
                ]))
              }), 128))
            ])
          ])
        ])),
    _createVNode(_component_ModalAddPayment, {
      openModal: _ctx.paywall,
      "onUpdate:openModal": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paywall) = $event))
    }, null, 8, ["openModal"])
  ]))
}